import { t } from "i18next";

import { Box, SxProps, Tooltip, Typography, useTheme } from "@mui/material";

import { theme } from "@/src/theme/theme";

import AnimatedNumber from "@/src/components/atoms/AnimatedNumber/AnimatedNumber";

interface BidRowProps {
  highestBid: number;
  myHighestBid: number;
  ourHighestBid: number;
  isEnded?: boolean;
  isVatDeductible?: boolean;
  myBidRank?: number;
  sx?: SxProps;
}

const BidRow = (props: BidRowProps) => {
  const theme = useTheme();
  const { highestBid, myHighestBid, isVatDeductible, myBidRank, sx } = props;
  let color: string = theme.palette.text.secondary;
  let backgroundColor = "transparent";

  if (typeof myBidRank === "number") {
    if (myBidRank === 1) {
      color = theme.palette.semantic.success.main;
      backgroundColor = theme.palette.semantic.success.focus12p;
    } else {
      color = theme.palette.semantic.error.main;
      backgroundColor = theme.palette.semantic.error.focus12p;
    }
  } else if (myHighestBid > 0) {
    if (myHighestBid >= highestBid) {
      color = theme.palette.semantic.success.main;
      backgroundColor = theme.palette.semantic.success.focus12p;
    } else {
      color = theme.palette.semantic.error.main;
      backgroundColor = theme.palette.semantic.primary.focus12p;
    }
  }

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          ...sx,
          backgroundColor: backgroundColor
        }}
      >
        <Box
          sx={{
            width: "50%",
            borderRight: "1px solid",
            borderColor: theme.palette.divider,
            textAlign: "center",
            boxSizing: "border-box"
          }}
        >
          <Typography variant="body2">
            {t("components.bidRow.highestBid")}
          </Typography>
          <AnimatedNumber
            variant="h3"
            value={highestBid}
            suffix=" €"
            sx={{
              fontWeight: theme.typography.fontWeightBold,
              textTransform: "uppercase",
              pb: 0
            }}
          />
          {isVatDeductible && (
            <Tooltip title={t("components.bidRow.vatDeductible.description")}>
              <Typography
                variant="body2"
                sx={{ color: theme.palette.text.secondary }}
              >
                {t("components.bidRow.vatDeductible.title")}
              </Typography>
            </Tooltip>
          )}
        </Box>
        <Box
          sx={{
            width: "50%",
            textAlign: "center",
            boxSizing: "border-box"
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: theme.palette.text.secondary
            }}
          >
            {t("components.bidRow.myBid")}
          </Typography>
          <AnimatedNumber
            variant="h3"
            value={myHighestBid}
            suffix=" €"
            sx={{
              fontWeight: theme.typography.fontWeightBold,
              textTransform: "uppercase",
              pb: 0,
              color: color
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default BidRow;
